var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-dialog",
    {
      attrs: {
        value: _vm.value,
        position: "right",
        "full-height": "",
        "content-class": "mobile-menu",
        square: ""
      },
      on: {
        input: function($event) {
          return _vm.$emit("input", $event)
        }
      }
    },
    [
      _c(
        "q-card",
        { staticStyle: { width: "var(--menu-width)" } },
        [
          _c(
            "q-toolbar",
            {
              staticClass: "justify-between",
              staticStyle: { height: "var(--header-height)" }
            },
            [
              _c(
                "q-btn",
                { attrs: { round: "", flat: "" }, on: { click: _vm.user } },
                [
                  _c("q-avatar", {
                    attrs: { size: "33px" },
                    domProps: { innerHTML: _vm._s(_vm.iconAva) }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("q-btn", {
                directives: [{ name: "close-popup", rawName: "v-close-popup" }],
                attrs: { flat: "", round: "", dense: "", icon: "close" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-scroll-area",
            { staticClass: "mobile-menu__scroll-area" },
            [
              _c(
                "q-card-section",
                { staticClass: "q-pa-none" },
                _vm._l(_vm.menu, function(m) {
                  return _c(
                    "div",
                    {
                      key: m.title,
                      staticClass: "layout-menu-item",
                      class: { active: _vm.isActive(m.path) },
                      on: {
                        click: function($event) {
                          return _vm.menuHandler(m)
                        }
                      }
                    },
                    [
                      _c("div", {
                        staticClass: "layout-menu-item-icon",
                        domProps: { innerHTML: _vm._s(m.icon) }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "layout-menu-item-title" }, [
                        _vm._v(
                          "\n            " + _vm._s(m.title) + "\n          "
                        )
                      ])
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("q-separator"),
              _vm._v(" "),
              _c("q-card-section", { staticClass: "q-pa-none" }, [
                _c(
                  "div",
                  {
                    staticClass: "layout-menu-item",
                    on: { click: _vm.logout }
                  },
                  [
                    _c("div", {
                      staticClass: "layout-menu-item-icon",
                      domProps: { innerHTML: _vm._s(_vm.iconExit) }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "layout-menu-item-title" }, [
                      _vm._v("\n            Выход\n          ")
                    ])
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }